import { render, staticRenderFns } from "./UpdateCompletionDate.vue?vue&type=template&id=11dc6d12"
import script from "./UpdateCompletionDate.vue?vue&type=script&lang=js"
export * from "./UpdateCompletionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports